import { render } from "./PartialList.vue?vue&type=template&id=1f97c7ac"
import script from "./PartialList.vue?vue&type=script&lang=js"
export * from "./PartialList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__